// eslint-disable-next-line @typescript-eslint/no-unused-vars

import { Link } from "react-router";
import { Theme, useTheme } from "~/helpers/ThemeProvider";
import { FaMoon, FaSun } from "react-icons/fa";
import { useEffect } from "react";
import { useRcStatus } from "~/helpers/RcContext";

export default function Header() {
  const [theme, setTheme] = useTheme();
  const [status, setStatus] = useRcStatus();

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT,
    );
  };
  // rgb(205, 199, 190)
  return (
    <header
      id="title-link"
      className="header-grid bg-light-header-color h-[70px] dark:bg-transparent dark:text-gray-300"
    >
      <div />
      <Link
        to="/"
        className="flex justify-center self-center font-['Russo_One'] text-3xl sm:text-4xl"
      >
        RollCall2{" "}
        {status?.currentSubscriber && <span className="ms-4">Pro</span>}
      </Link>

      <div className="flex items-center self-center">
        <button onClick={toggleTheme} title="Change Theme">
          {theme == Theme.DARK ? (
            <div className="">
              <FaSun />
            </div>
          ) : (
            <div className="">
              <FaMoon />
            </div>
          )}
        </button>
      </div>
    </header>
  );
}
